module.exports = __WEBPACK_EXTERNAL_MODULE_179__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.regexp.split"
// module id = 179
// module chunks = 0